import http, { ensureCsrfCookie } from "../../api/http";

/**
 * État d'authentification gardé uniquement en mémoire.
 *
 * Rien n'est écrit dans localStorage / sessionStorage : à chaque chargement de l'application,
 * la session (cookie HttpOnly) est revérifiée auprès de l'API via GET /user.
 */
export default {
  namespaced: true,
  state: {
    user: null,
    roles: [],
    permissions: [],
    isAuthenticated: false,
    checked: false,
  },
  mutations: {
    setUser(state, data) {
      state.user = data.user ?? null;
      state.roles = data.roles ?? [];
      state.permissions = data.permissions ?? [];
      state.isAuthenticated = Boolean(data.user);
      state.checked = true;
    },
    clearUser(state) {
      state.user = null;
      state.roles = [];
      state.permissions = [];
      state.isAuthenticated = false;
      state.checked = true;
    },
    UPDATE_USER_PHOTO(state, photoUrl) {
      if (state.user) {
        state.user = { ...state.user, photo: photoUrl };
      }
    },
    setMustChangePassword(state, value) {
      if (state.user) {
        state.user = { ...state.user, must_change_password: value };
      }
    },
  },
  actions: {
    async login({ dispatch }, credentials) {
      await ensureCsrfCookie(true);
      const { data } = await http.post("login", credentials);
      await dispatch("fetchUser");
      return data.data;
    },

    async fetchUser({ commit }) {
      try {
        const { data } = await http.get("user", { skipAuthRedirect: true });
        commit("setUser", data.data);
        return data.data;
      } catch (error) {
        commit("clearUser");
        throw error;
      }
    },

    /**
     * Vérifie la session une seule fois au démarrage (ou après une déconnexion).
     */
    async ensureSession({ state, dispatch }) {
      if (state.checked) {
        return state.isAuthenticated;
      }
      try {
        await dispatch("fetchUser");
      } catch (error) {
        return false;
      }
      return state.isAuthenticated;
    },

    async logout({ commit }) {
      try {
        await http.post("logout");
      } catch (error) {
        // La session est déjà invalide côté serveur : on nettoie localement.
      } finally {
        commit("clearUser");
      }
    },
  },
  getters: {
    user: (state) => state.user,
    isAuthenticated: (state) => state.isAuthenticated,
    mustChangePassword: (state) => Boolean(state.user?.must_change_password),
    hasPermission: (state) => (permission) => state.permissions.includes(permission),
    hasAnyPermission: (state) => (permissions) => permissions.some((permission) => state.permissions.includes(permission)),
    hasRole: (state) => (role) => state.roles.includes(role),
  },
};
